import { Link } from "react-router-dom";
import { H4 } from "../../../AbstractElements";

export const invoiceColumns = (authState, ActionCell) => [
    {
        name: <H4>Sl</H4>,
        selector: row => row.Si,
        width: '60px'
    },
    {
        name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
        selector: row => row.action,
        cell: row => <ActionCell row={row} />,
        center: true,
        width: '55px'
    },
    {
        name: <H4>Invoice ID</H4>,
        id: 'invoice_no',
        selector: row =>
            <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile/invoice?invoice_id=${row.id}&customer_id=${row.customer_id}`}>
                {row.InvoiceNo}
            </Link>,
        sortable: true,
        wrap: true,
        width: '120px'
    },

    {
        name: <H4>Name</H4>,
        id: 'name',
        selector: row => row.Customer,
        sortable: true,
        width: '100px',
        wrap: true
    },
    {
        name: <H4>Customer Id</H4>,
        id: 'subscriber_id',
        selector: row =>
            (authState.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
                <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.customer_id}`}>
                    {row.Subs}
                </Link> : row.Subs,
        sortable: true,
        width: '165px'
    },
    {
        name: <H4>Bin ID</H4>,
        id: 'bin_account',
        selector: row => row.Sub,
        sortable: true,
        wrap: true,
        width: '120px',
    },
    {
        name: <H4>Invoice Type</H4>,
        id: 'invoice_type',
        selector: row => row.con_type,
        sortable: true,
        wrap: true,
        width: '120px',
    },
    {
        name: <H4>Amount</H4>,
        id: 'amount',
        selector: row => `${authState.currency} ${row.Amount}`,
        sortable: true,
        width: '105px',
    },
    {
        name: <H4>Invoice date</H4>,
        id: 'invoice_date',
        selector: row => row.InvoiceDate,
        sortable: true,
        width: '165px'
    },
    {
        name: <H4>Due Date</H4>,
        id: 'due_date',
        selector: row => row.PlanStartDate,
        sortable: true,
        width: '165px'
    },
    {
        name: <H4>Payment Status</H4>,
        selector: row => (<span
            className={`badge badge-${row.payment_status}`} >
            {row.payment_status}
        </span>
        ),
        width: '140px'
    },
    {
        name: <H4>Subscription Date</H4>,
        id: 'plan_date',
        selector: row => row.PlanDate,
        sortable: true,
        width: '165px'
    },
];

export const recurringColumns = (authState) => [
    {
        name: <H4>Sl</H4>,
        selector: row => row.Si,
    },
    {
        name: <H4>Customer Id</H4>,
        id: 'subscriber_id',
        selector: row =>
            (authState.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
                <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.Customer_id}`}>
                    {row.Sub}
                </Link> : row.Sub,
        sortable: true,
        wrap: true,
    },
    {
        name: <H4>Bin Id</H4>,
        id: 'stb_id',
        selector: row => row.BinId,
        sortable: true,
        wrap: true,
    },
    {
        name: <H4>Customer</H4>,
        id: 'customer_name',
        selector: row => row.Customer,
        sortable: true,
        wrap: true
    },
    {
        name: <H4>Start Date</H4>,
        id: 'start_date',
        selector: row => row.StartDate,
        sortable: true,
        wrap: true
    },
    {
        name: <H4>End Date</H4>,
        id: 'end_date',
        selector: row => row.EndDate,
        sortable: true,
        wrap: true
    },
    {
        name: <H4>Package Name</H4>,
        id: 'package_name',
        selector: row => row.PackageName,
        sortable: true,
        wrap: true
    },
];

export const orderColumns = (authState) => [
    {
        name: <H4>Sl</H4>,
        selector: row => row.Si,
    },
    {
        name: <H4>Customer Id</H4>,
        id: 'customer_id',
        selector: row =>
            (authState.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
                <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.Customer_id}`}>
                    {row.Customer_id}
                </Link> : row.Customer_id,
        sortable: true,
        wrap: true,
    },
    {
        name: <H4>Status</H4>,
        selector: row => row.Status,
        width: '100px',
        cell: row => (
            <span
                className={`badge badge-${row.Status}`}
            >
                {row.Status}
            </span>
        ),
    },
    {
        name: <H4>Item Name</H4>,
        id: 'items',
        selector: row => row.Item,
        sortable: true,
        wrap: true,
    },
    // {
    //     name: <H4>Item Option</H4>,
    //     id: 'customer_name',
    //     selector: row => row.Customer,
    //     sortable: true,
    //     wrap: true
    // },
    {
        name: <H4>Customer</H4>,
        id: 'customer_name',
        selector: row => row.Name,
        sortable: true,
        wrap: true
    },
    {
        name: <H4>Date</H4>,
        id: 'invoice_date',
        selector: row => row.Date,
        sortable: true,
        wrap: true
    },
    {
        name: <H4>Invoice ID</H4>,
        id: 'invoice_no',
        selector: row =>
            <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile/invoice?invoice_id=${row.id}&customer_id=${row.Customer_id}`}>
                {row.InvoiceNo}
            </Link>,
        sortable: true,
        wrap: true,
    },
    {
        name: <H4>Amount</H4>,
        id: 'order_total',
        selector: row => row.Amount,
        sortable: true,
        wrap: true
    },
];